module.exports = __webpack_public_path__ + "img/img_Colleges5.fc5e67cd.png";